import axios from './index';

class LockersApi {
  static List = (data) => {
    let query = '?';
    if (data.status) {
      query += `status=${data.status}&`;
    }
    if (data.customerId) {
      query += `user_id=${data.customerId}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.selectedStatusTypeValue) {
      query += `status_type=${data.selectedStatusTypeValue}&`;
    }
    if (data.selectedOrderTypeValue) {
      query += `order_type=${data.selectedOrderTypeValue}&`;
    }
    if (data.filterStartDate) {
      query += `start_date=${data.filterStartDate}&`;
    }
    if (data.filterEndDate) {
      query += `end_date=${data.filterEndDate}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}${query}`);
  };

  static Details = (data) => {
    let query = `?user_id=${data?.userId}`;
    // console.log(`lockers api call - ${base}/${query}`);
    return axios.get(`customer/admin/locker-details${query}`);
  };

  static Redeemjewel = (data) => {
    let request = {
      gold_weight: data.withdrawalWeight,
      operation_location_id: data.operationLocationId,
      user_id: data.userid,
      store_id: data.storeId,
    };
    return axios.post(`customer/admin/order/advanced-book-redeem-jewel`, request);
  };
}

let base = 'customer/admin/locker-list';

export default LockersApi;
